export default "__VITE_ASSET__B8kYABt1__"